/* Batch 6–10: one selected variant is one whole pack, with no selling plan. */
(() => {
  const core = {
    counts(values, shades) { return shades.map(shade => values.filter(value => value === shade).length); },
    match(variants, config, quantity, values) {
      if (!Number.isInteger(quantity) || quantity < 1) return;
      if (config.shades?.length && (values.length !== quantity || values.some(value => !config.shades.includes(value)))) return;
      const counts = this.counts(values, config.shades || []);
      return variants.find(variant => {
        const pack = config.bySku[variant.sku];
        return pack && pack.quantity === quantity &&
          JSON.stringify(pack.counts || []) === JSON.stringify(counts);
      });
    }
  };
  window.LoxhavenBatch2Core = Object.freeze(core);
  if (customElements.get('loxhaven-batch2-packs')) return;
  customElements.define('loxhaven-batch2-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-pack-config]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-pack-variants]').textContent);
      this.addEventListener('change', () => this.sync());
      const form = document.getElementById(this.dataset.form);
      // The native secondary CTA skips the drawer. Keep its appearance, but
      // expose the same optional protection choice as the primary batch CTA.
      form?.addEventListener('click', event => {
        if (!event.target.closest('[data-skip-cart-button="true"]')) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.addToCart();
      }, true);
      // Native ProductForm owns the request and its loading state. Reapply
      // availability after its finally handler, including selections made while busy.
      if (form) {
        let wasSubmitting = this.isSubmitting(form);
        new MutationObserver(() => {
          const submitting = this.isSubmitting(form);
          if (wasSubmitting && !submitting) this.sync();
          wasSubmitting = submitting;
        }).observe(form, {subtree: true, attributes: true, attributeFilter: ['class']});
      }
      const sticky = document.getElementById('sticky-atc-' + this.dataset.section);
      sticky?.addEventListener('change', event => {
        if (!event.target.matches('select')) return;
        event.stopImmediatePropagation();
        const option = event.target.selectedOptions[0];
        const variant = this.variants.find(v => String(v.id) === option.dataset.variantId || v.option1 === option.value);
        if (variant) { this.selectVariant(variant); this.sync(); }
      }, true);
      sticky?.addEventListener('click', event => {
        if (!event.target.closest('.sticky-atc__add_button') || sticky.dataset.scrollBtn === 'true') return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.addToCart();
      }, true);
      const requested = new URL(location.href).searchParams.get('variant');
      const variant = this.variants.find(v => String(v.id) === requested);
      if (variant) this.selectVariant(variant);
      this.sync();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.sync(), {once: true});
    }
    isSubmitting(form) {
      return Boolean(form?.querySelector('button[name="add"].loading, [data-skip-cart-button].loading'));
    }
    addToCart() {
      const form = document.getElementById(this.dataset.form);
      if (this.isSubmitting(form)) return;
      this.sync();
      const button = form?.querySelector('button[name="add"]');
      if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') button.click();
    }
    selectVariant(variant) {
      const pack = this.config.bySku[variant.sku];
      const card = pack && this.querySelector(`[data-size="${pack.quantity}"]`);
      if (!card) return;
      card.querySelector('input[type="radio"]').checked = true;
      const values = (this.config.shades || []).flatMap((shade, index) => Array(pack.counts[index]).fill(shade));
      card.querySelectorAll('select').forEach((select, index) => { select.value = values[index]; });
    }
    sync() {
      const radio = this.querySelector('input[type="radio"]:checked');
      if (!radio) return;
      const card = this.querySelector(`[data-size="${radio.value}"]`);
      const variant = core.match(this.variants, this.config, Number(radio.value), [...card.querySelectorAll('select')].map(s => s.value));
      this.querySelectorAll('.lxb2-pack').forEach(item => item.classList.toggle('is-selected', item === card));
      const form = document.getElementById(this.dataset.form);
      const sticky = document.getElementById('sticky-atc-' + this.dataset.section);
      const available = Boolean(variant?.available);
      const id = form?.querySelector('[name="id"]');
      if (id) { id.disabled = !available; if (variant) id.value = variant.id; }
      form?.querySelectorAll('[name="selling_plan"]').forEach(input => { input.disabled = true; });
      // A pack/shade sync must never release native ProductForm's in-flight lock.
      if (!this.isSubmitting(form)) {
        form?.querySelectorAll('button[name="add"], [data-skip-cart-button]').forEach(button => { button.disabled = !available; button.setAttribute('aria-disabled', String(!available)); });
        sticky?.querySelectorAll('.sticky-atc__add_button').forEach(button => { button.disabled = !available; });
      }
      if (!variant) { this.dataset.selectedVariant = ''; return; }
      const installment = document.getElementById('product-form-installment-' + this.dataset.section);
      if (installment?.querySelector('[name="id"]')) installment.querySelector('[name="id"]').value = variant.id;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: this.dataset.currency || 'USD'});
      const compare = Number(variant.compare_at_price || 0);
      const price = Number(variant.price);
      for (const root of [document.getElementById('price-' + this.dataset.section), sticky]) {
        root?.querySelectorAll('.price-item--regular,.price-item--sale').forEach(el => { el.textContent = money.format((el.matches('s') || el.closest('s') ? compare : price) / 100); });
        root?.querySelectorAll('.badge__percentage-saved').forEach(el => { el.textContent = compare > price ? Math.floor((compare - price) * 100 / compare) : 0; });
        root?.querySelectorAll('.badge__money-saved').forEach(el => { el.textContent = money.format(Math.max(0, compare - price) / 100); });
      }
      sticky?.querySelectorAll('select').forEach(select => {
        const option = [...select.options].find(o => o.dataset.variantId === String(variant.id) || o.value === variant.option1);
        if (option) select.value = option.value;
      });
      this.dataset.selectedVariant = variant.id;
    }
  });
})();
